import { computePosition as Q, offset as X, shift as Y, flip as Z, hide as P, size as x, autoUpdate as _ } from "@floating-ui/dom";
import { onClickOutside as ee } from "@vueuse/core";
import { computed as r, unref as B, ref as m, shallowRef as te, watch as M, getCurrentScope as oe, onScopeDispose as ne, shallowReadonly as h, defineComponent as ae, toRefs as re, toRef as le, resolveComponent as H, openBlock as D, createBlock as N, withCtx as V, withDirectives as z, createElementVNode as se, normalizeClass as U, createElementBlock as W, mergeProps as L, renderSlot as j, vShow as q, createCommentVNode as F } from "vue";
import { usePopoverState as ie, useResponsive as ue, useElevation as de } from "@onereach/ui-components-common/hooks";
import { O as fe } from "./OrBottomSheet-CJxmY84p.mjs";
import { O as me } from "./OrTeleport.vue3-C9kW_8PS.mjs";
import { isAncestor as pe } from "@onereach/ui-components-common/utils";
import { _ as ce } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
function G(e, l) {
  const t = J(e);
  return Math.round(l * t) / t;
}
function J(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function I(e) {
  return (e == null ? void 0 : e.$el) ?? e;
}
function ve(e, l, t = {}) {
  const o = t.whileElementsMounted, c = r(() => B(t.open) ?? !0), g = r(() => B(t.middleware)), d = r(() => B(t.placement) ?? "bottom"), u = r(() => B(t.strategy) ?? "absolute"), S = r(() => B(t.transform) ?? !0), p = r(() => I(e.value)), s = r(() => I(l.value)), b = m(0), w = m(0), f = m(u.value), E = m(d.value), O = te({}), k = m(!1), C = r(() => {
    const i = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!s.value)
      return i;
    const n = G(s.value, b.value), $ = G(s.value, w.value);
    return S.value ? {
      ...i,
      transform: `translate(${n}px, ${$}px)`,
      ...J(s.value) >= 1.5 && { willChange: "transform" }
    } : {
      position: f.value,
      left: `${n}px`,
      top: `${$}px`
    };
  });
  let v;
  function y() {
    p.value == null || s.value == null || Q(p.value, s.value, {
      middleware: g.value,
      placement: d.value,
      strategy: u.value
    }).then((i) => {
      b.value = i.x, w.value = i.y, f.value = i.strategy, E.value = i.placement, O.value = i.middlewareData, k.value = !0;
    });
  }
  function R() {
    typeof v == "function" && (v(), v = void 0);
  }
  function T() {
    if (R(), o === void 0) {
      y();
      return;
    }
    if (p.value != null && s.value != null) {
      v = o(
        p.value,
        s.value,
        y
      );
      return;
    }
  }
  function A() {
    c.value || (k.value = !1);
  }
  return M([g, d, u], y, {
    flush: "sync"
  }), M([p, s], T, { flush: "sync" }), M(c, A, { flush: "sync" }), oe() && ne(R), {
    x: h(b),
    y: h(w),
    strategy: h(f),
    placement: h(E),
    middlewareData: h(O),
    isPositioned: h(k),
    floatingStyles: C,
    update: y
  };
}
var K = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Popover = "popover", e.BottomSheet = "bottom-sheet", e))(K || {}), a = /* @__PURE__ */ ((e) => (e.Top = "top", e.TopStart = "top-start", e.TopEnd = "top-end", e.Bottom = "bottom", e.BottomStart = "bottom-start", e.BottomEnd = "bottom-end", e.Left = "left", e.LeftStart = "left-start", e.LeftEnd = "left-end", e.Right = "right", e.RightStart = "right-start", e.RightEnd = "right-end", e))(a || {});
const ye = [
  // Position
  "absolute"
], he = [
  // Shape
  "rounded-md",
  // Spacing
  "mx-sm",
  "my-sm",
  // Elevation
  "shadow-contextual",
  "dark:shadow-contextual-dark",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], ge = {
  [a.Top]: [
    // Spacing
    "mb-0"
  ],
  [a.TopStart]: [
    // Spacing
    "mb-0",
    "ml-0"
  ],
  [a.TopEnd]: [
    // Spacing
    "mb-0",
    "mr-0"
  ],
  [a.Bottom]: [
    // Spacing
    "mt-0"
  ],
  [a.BottomStart]: [
    // Spacing
    "mt-0",
    "ml-0"
  ],
  [a.BottomEnd]: [
    // Spacing
    "mt-0",
    "mr-0"
  ],
  [a.Left]: [
    // Spacing
    "mr-0"
  ],
  [a.LeftStart]: [
    // Spacing
    "mr-0",
    "mt-0"
  ],
  [a.LeftEnd]: [
    // Spacing
    "mr-0",
    "mb-0"
  ],
  [a.Right]: [
    // Spacing
    "ml-0"
  ],
  [a.RightStart]: [
    // Spacing
    "ml-0",
    "mt-0"
  ],
  [a.RightEnd]: [
    // Spacing
    "ml-0",
    "mb-0"
  ]
};
function Se(e, l) {
  return e.some((t) => {
    const { classList: o } = t;
    return !!(!pe(t, l) && (o != null && o.contains("or-popover-v3") || o != null && o.contains("or-bottom-sheet-v3") || o != null && o.contains("or-confirm-v3")));
  });
}
const be = ae({
  name: "OrPopover",
  components: {
    OrBottomSheet: fe,
    OrTeleport: me
  },
  inheritAttrs: !1,
  props: {
    // @workaround for Vue 2
    customStyles: {
      type: Array,
      default: () => []
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: () => K.Auto
    },
    bottomSheetProps: {
      type: Object,
      default: void 0
    },
    trigger: {
      type: Object,
      default: void 0
    },
    placement: {
      type: String,
      default: () => a.Bottom
    },
    fallbackPlacement: {
      type: String,
      default: "end"
    },
    hideOptions: {
      type: Object,
      default: void 0
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    disableDefaultStyles: {
      type: Boolean,
      default: !1
    },
    keepAlive: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "isFlipped",
    "isHidden",
    "open",
    "close",
    "toggle",
    "bottomSheet"
  ],
  setup(e, l) {
    const t = m(), o = m(), c = m(), g = r(() => {
      var n;
      return (n = c.value) == null ? void 0 : n.root;
    }), { trigger: d, placement: u, offset: S, fullWidth: p, hideOptions: s } = re(e), b = r(() => [
      "or-popover-v3",
      ...ye,
      ..."class" in l.attrs ? [] : e.customStyles
    ]), w = r(() => [
      ...he,
      ...ge[u.value]
    ]), { state: f, open: E, close: O, toggle: k } = ie(le(e, "isOpen"), l.emit), { floatingStyles: C, middlewareData: v, placement: y } = ve(d, t, {
      placement: u,
      middleware: [
        X(S.value),
        Y(),
        Z(() => ({ fallbackAxisSideDirection: e.fallbackPlacement })),
        P(s.value),
        x({
          apply({ rects: n, elements: $ }) {
            p.value && Object.assign($.floating.style, {
              width: `${n.reference.width}px`
            });
          }
        })
      ],
      whileElementsMounted(...n) {
        return _(...n, { animationFrame: !0 });
      }
    }), R = r(() => y.value !== u.value), T = r(() => {
      var n;
      return !!((n = v.value.hide) != null && n.referenceHidden);
    }), { isDesktop: A, isMobile: i } = ue(o);
    return de(t, f), ee(t, (n) => {
      f.value === "open" && !Se(n.composedPath(), e.trigger) && O();
    }, {
      ignore: [d]
    }), {
      root: t,
      containerRoot: o,
      bottomSheet: c,
      bottomSheetRoot: g,
      rootStyles: b,
      bodyStyles: w,
      floatingStyles: C,
      state: f,
      isFlipped: R,
      isHidden: T,
      isDesktop: A,
      isMobile: i,
      open: E,
      close: O,
      toggle: k
    };
  }
});
function we(e, l, t, o, c, g) {
  const d = H("OrBottomSheet"), u = H("OrTeleport");
  return e.keepAlive || e.state === "open" ? (D(), N(u, { key: 0 }, {
    default: V(() => [
      z(se("div", {
        ref: "containerRoot",
        class: U(["contents", "my-state" + e.state])
      }, [
        e.isDesktop && e.variant === "auto" || e.variant === "popover" ? z((D(), W("div", L({ key: 0 }, e.$attrs, {
          ref: "root",
          class: e.rootStyles,
          style: e.floatingStyles
        }), [
          e.disableDefaultStyles ? j(e.$slots, "default", { key: 0 }) : (D(), W("div", {
            key: 1,
            class: U(e.bodyStyles)
          }, [
            j(e.$slots, "default")
          ], 2))
        ], 16)), [
          [q, !e.isHidden]
        ]) : F("", !0),
        e.isMobile && e.variant === "auto" || e.variant === "bottom-sheet" ? (D(), N(d, L({
          key: 1,
          ref: "bottomSheet"
        }, e.bottomSheetProps, {
          "is-open": e.state === "open",
          "onUpdate:state": l[0] || (l[0] = (S) => S === "open" ? e.open() : e.close())
        }), {
          default: V(() => [
            j(e.$slots, "default")
          ]),
          _: 3
        }, 16, ["is-open"])) : F("", !0)
      ], 2), [
        [q, e.state === "open"]
      ])
    ]),
    _: 3
  })) : F("", !0);
}
const Te = /* @__PURE__ */ ce(be, [["render", we]]);
export {
  Te as O,
  K as P,
  a,
  Se as i
};
//# sourceMappingURL=OrPopover-DbygLPtT.mjs.map
